(function() {
  if (!/\/(collections|search)/.test(window.location.pathname) && !/\/search/.test(window.location.pathname)) return;

  function countActiveFilters() {
    var params = new URLSearchParams(window.location.search);
    var n = 0;
    params.forEach(function(_, key) {
      if (key.indexOf('filter.') === 0) n++;
    });
    return n;
  }

  function findFilterTrigger() {
    return document.querySelector('[aria-controls*="facets"], [aria-controls*="filter"], button[data-action*="filter"], .filter-trigger, [class*="filters-drawer"][class*="open"]') ||
           Array.from(document.querySelectorAll('button, a')).find(function(el) {
             var t = (el.textContent || '').toLowerCase().trim();
             return /^filtrer(\s|$)|filtres?$/.test(t);
           });
  }

  function updateBadge() {
    var n = countActiveFilters();
    var trigger = findFilterTrigger();
    if (!trigger) return;
    var badge = trigger.querySelector('.hl-filter-badge');
    if (n === 0) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'hl-filter-badge';
      trigger.appendChild(badge);
    }
    badge.textContent = n;
  }

  function init() {
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-run on URL change (some themes do AJAX filter)
  window.addEventListener('popstate', updateBadge);
  // 2026-10-30 : bouton maison « Voir les produits » retire. Il fermait le tiroir sans appliquer les filtres ;
  // le bouton « Appliquer » du theme, en bas du tiroir, suffit.
})();